import {CanActivateFn, Router} from '@angular/router';
import {inject} from '@angular/core';
import {AuthService} from '../../services/auth/auth';

export const rootRedirectGuard: CanActivateFn = async () => {
  const auth: AuthService = inject(AuthService);
  const router: Router = inject(Router);

  await auth.loadToken();

  return router.createUrlTree([auth.isLoggedIn() ? '/home' : '/login']);
};
